import { useScaleFactor, useSpaceSize } from "arkh";
import React, { PropsWithChildren, useMemo } from "react";
import { StyleProp, View, ViewStyle } from "react-native";
import { graphql, useFragment } from "react-relay";

import { EmployeeScheduleShiftBar } from "./EmployeeScheduleShiftBar";
import { EmployeeScheduleShiftsEmployee_employee$key } from "./__generated__/EmployeeScheduleShiftsEmployee_employee.graphql";

export const Employee = React.memo(EmployeeCmp);
function EmployeeCmp(props: {
  employee: EmployeeScheduleShiftsEmployee_employee$key;

  listItemHeight: number;

  dayStartMinutes: number;
  boxWidth: number;
}) {
  const employee = useFragment(
    graphql`
      fragment EmployeeScheduleShiftsEmployee_employee on Employee {
        id
        ...EmployeeScheduleNameEmployeeNamePanel_employee
        shifts {
          id
          ...EmployeeScheduleShiftBar
        }
      }
    `,
    props.employee
  );

  return (
    <View
      style={{
        height: props.listItemHeight,
        justifyContent: "center",
      }}
    >
      <ShiftCanvas>
        {employee.shifts.map((shift, i) => (
          <EmployeeScheduleShiftBar
            key={shift.id}
            shift={shift}
            boxWidth={props.boxWidth}
            showTime
            dayStartMinutes={props.dayStartMinutes}
          />
        ))}
      </ShiftCanvas>
    </View>
  );
}

function ShiftCanvas(props: PropsWithChildren) {
  const sf = useScaleFactor();
  const spaceLeft = useSpaceSize("xsmall");
  const style: StyleProp<ViewStyle> = useMemo(
    () => ({
      overflow: "hidden",
      height: 30 * sf,
      justifyContent: "center",
      left: 0,
      paddingLeft: spaceLeft,
      width: "100%",
      position: "absolute",
    }),
    [sf, spaceLeft]
  );
  return <View style={style}>{props.children}</View>;
}
